const footerData = {
  footerMenus: [
    {
      title: 'main',
      list: [
        {
          name: 'About us',
          url: '/about-us'
        }, {
          name: 'Wat\'s New',
          url: '/about-us'
        }, {
          name: 'Stores',
          url: '/about-us'
        }, {
          name: 'Entertainment',
          url: '/about-us'
        }, {
          name: 'Services',
          url: '/about-us'
        }, {
          name: 'For Kids',
          url: '/about-us'
        }
      ]
    }, {
      title: 'INFORMATION',
      list: [
        {
          name: 'About Company',
          url: '/about-us'
        }, {
          name: 'Media',
          url: '/about-us'
        }, {
          name: 'Career',
          url: '/about-us'
        }, {
          name: 'How to Get',
          url: '/about-us'
        }, {
          name: 'Contact',
          url: '/about-us'
        }
      ]
    }, {
      title: 'SOCIALS',
      list: [
        {
          name: 'Facebook',
          url: '/Facebook'
        }, {
          name: 'Twitter',
          url: '/Facebook'
        }, {
          name: 'Pinterest',
          url: '/Facebook'
        }, {
          name: 'Youtube',
          url: '/Facebook'
        }
      ]
    }
  ],
  footerInfo: [
    {
      title: 'working hours',
      content: ''
    }
  ]
}

export default footerData
